import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Button from 'shopper/components/Button';
import Flex from 'shopper/components/Flex';

import WishlistIcon from 'components/Icons/Wishlist';

import { sendEvent } from 'lib/gtag';

import { useModal } from 'providers/ModalProvider';

import LINKS from 'constants/links';
import WISHLIST from 'constants/wishlist';

const SuggestNewCouponButton = dynamic(() =>
  import('./SuggestNewCouponButton')
);
const SuggestNewOfferButton = dynamic(() => import('./SuggestNewOfferButton'));
const SuggestNewThreadButton = dynamic(() =>
  import('./SuggestNewThreadButton')
);
const WishlistModal = dynamic(
  () => import('components/Wishlist/WishlistModal'),
  { ssr: false }
);

const TopbarBottomRightNav = ({ currInitialPath, gaEventCategory }) => {
  const { showModal } = useModal();

  const onWishlistButtonClick = () => {
    sendEvent({ action: 'show_wishlist', category: gaEventCategory });
    showModal(WishlistModal, { isOpen: true });
  };

  const buttonsByPage = useMemo(
    () => ({
      [LINKS.COUPONS]: <SuggestNewCouponButton />,
      [LINKS.FORUM]: <SuggestNewThreadButton />,
      default: <SuggestNewOfferButton />,
    }),
    []
  );

  return (
    <Flex flex="2" justifyContent="flex-end">
      <Button
        type="subtle"
        size="size2"
        data-test-selector="open-wishlist"
        iconLeft={<WishlistIcon />}
        mobileIcon={<WishlistIcon />}
        onClick={onWishlistButtonClick}
      >
        {WISHLIST.TITLE}
      </Button>
      {buttonsByPage[currInitialPath] ?? buttonsByPage.default}
    </Flex>
  );
};

TopbarBottomRightNav.defaultProps = {
  currInitialPath: null,
};

TopbarBottomRightNav.propTypes = {
  currInitialPath: PropTypes.string,
  gaEventCategory: PropTypes.string.isRequired,
};

export default TopbarBottomRightNav;
